import {
  GetFlaggedNoteDocument,
  ListNotesDocument,
} from '@fdha/graphql-api-admin';

// Must match the `$first: Int = 10` default on the `notes` query in
// graphql-api-admin/src/graphql/queries.graphql so refetch variables
// match the active `useListNotesQuery` observer exactly.
export const INITIAL_NOTES_PER_PAGE = 10;

export const buildListNotesRefetch = (patientId: string) => ({
  query: ListNotesDocument,
  variables: { first: INITIAL_NOTES_PER_PAGE, patientId },
});

export const buildFlaggedNoteRefetch = (patientId: string) => ({
  query: GetFlaggedNoteDocument,
  variables: { patientId },
});
